/* global pdfMake */

angular.module("kitstajm").factory("invoiceOldPdf", function ($filter, config) {
  // Closure
  (function () {
    /**
     * Decimal adjustment of a number.
     *
     * @param {String}  type  The type of adjustment.
     * @param {Number}  value The number.
     * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
     * @returns {Number} The adjusted value.
     */
    function decimalAdjust(type, value, exp) {
      // If the exp is undefined or zero...
      if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
      }
      value = +value;
      exp = +exp;
      // If the value is not a number or the exp is not an integer...
      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
      }
      // Shift
      value = value.toString().split("e");
      value = Math[type](
        +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))
      );
      // Shift back
      value = value.toString().split("e");
      return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
    }

    // Decimal round
    if (!Math.round10) {
      Math.round10 = function (value, exp) {
        return decimalAdjust("round", value, exp);
      };
    }
    // Decimal floor
    if (!Math.floor10) {
      Math.floor10 = function (value, exp) {
        return decimalAdjust("floor", value, exp);
      };
    }
    // Decimal ceil
    if (!Math.ceil10) {
      Math.ceil10 = function (value, exp) {
        return decimalAdjust("ceil", value, exp);
      };
    }
  })();

  var createPdf = function (statement) {
    //                console.log(statement);
    var statementDetail = JSON.parse(statement.statement);
    //console.log(statementDetail);
    var invoiceHeader = "Faktura";
    var totAmount = "Totalt att betala";

    if (
      statementDetail.statementType &&
      statementDetail.statementType === "kredit"
    ) {
      invoiceHeader = "Kreditfaktura";
      totAmount = "Totalt er tillgodo";
    }

    statement.detailMode = statementDetail.detailMode;

    var invoice = {};
    invoice.companyName = statementDetail.companyInfo.legalname
      ? statementDetail.companyInfo.legalname.toString()
      : "";
    invoice.companyAdress1 = statementDetail.companyInfo.address1
      ? statementDetail.companyInfo.address1.toString()
      : "";
    invoice.companyAdress2 = statementDetail.companyInfo.address2
      ? statementDetail.companyInfo.address2.toString()
      : "";
    invoice.companyZipcode = statementDetail.companyInfo.zipcode
      ? statementDetail.companyInfo.zipcode.toString()
      : "";
    invoice.companyCity = statementDetail.companyInfo.city
      ? statementDetail.companyInfo.city.toString()
      : "";
    invoice.companyCountry = statementDetail.companyInfo.country
      ? statementDetail.companyInfo.country.toString()
      : "";
    invoice.invoiceNo = statement.invoice_number
      ? statement.invoice_number.toString()
      : "";
    invoice.date = statement.inputdate ? statement.inputdate.toString() : "";
    invoice.terms = statementDetail.payment_term
      ? statementDetail.payment_term.toString()
      : "";
    invoice.customerName = statementDetail.legalname
      ? statementDetail.legalname.toString()
      : "";
    invoice.customerOrgNo = statementDetail.vatno
      ? statementDetail.vatno.toString()
      : "";
    invoice.customerVATNo = statementDetail.orgno
      ? statementDetail.vatno.toString()
      : "";
    invoice.customerAdress1 = statementDetail.address1
      ? statementDetail.address1.toString()
      : "";
    invoice.customerAdress2 = statementDetail.address2
      ? statementDetail.address2.toString()
      : "";
    invoice.customerZipcode = statementDetail.zipcode
      ? statementDetail.zipcode.toString()
      : "";
    invoice.customerCity = statementDetail.city
      ? statementDetail.city.toString()
      : "";
    invoice.customerCountry = statementDetail.country
      ? statementDetail.country.toString()
      : "";
    invoice.customerContact = statementDetail.extreference
      ? statementDetail.extreference.toString()
      : "";
    invoice.customerRef = statementDetail.extprojectid
      ? statementDetail.extprojectid.toString()
      : "";
    invoice.companyContact = statementDetail.ourreference
      ? statementDetail.ourreference.toString()
      : "";
    invoice.companyRef = statementDetail.addinfo
      ? statementDetail.addinfo.toString()
      : "";
    invoice.period_start = statement.period_start
      ? statement.period_start.toString()
      : "";
    invoice.period_stop = statement.period_stop
      ? statement.period_stop.toString()
      : "";

    invoice.details = [];

    var detailHeader = [
      { text: "Projekt", style: "tableHeader" },
      { text: "Resurs", style: "tableHeader" },
      { text: "Aktivitet", style: "tableHeader" },
      { text: "Timmar", style: "tableHeader", alignment: "right" },
    ];

    var detailWidths = ["auto", "auto", "*", "auto"];

    var m;
    if (statement.detailMode === "P") {
      detailHeader = detailHeader.concat([
        { text: "á pris", style: "tableHeader", alignment: "right" },
        { text: "Belopp", style: "tableHeader", alignment: "right" },
      ]);
      detailWidths = detailWidths.concat(["auto", "auto"]);
      for (m = 0; m < statementDetail.details.length; m++) {
        invoice.details[m] = [];
        if (statementDetail.details[m].external_project_name) {
          statementDetail.details[m].project_name =
            statementDetail.details[m].external_project_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].project_name
            ? statementDetail.details[m].project_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].name
            ? statementDetail.details[m].name.toString()
            : "",
        });
        if (statementDetail.details[m].external_activity_name) {
          statementDetail.details[m].activity_name =
            statementDetail.details[m].external_activity_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].activity_name
            ? statementDetail.details[m].activity_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].sum.toString(),
          alignment: "right",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].price
            ? $filter("number")(statementDetail.details[m].price, 2)
            : "0",
          alignment: "right",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].pris
            ? $filter("number")(statementDetail.details[m].pris, 2)
            : "0",
          alignment: "right",
        });
      }
    }

    if (statement.detailMode === "D") {
      detailHeader.unshift([
        { text: "Datum", style: "tableHeader", alignment: "left" },
      ]);
      detailWidths.unshift(["auto"]);
      for (m = 0; m < statementDetail.details.length; m++) {
        invoice.details[m] = [];
        invoice.details[m].push({
          text: statementDetail.details[m].reporteddate
            ? $filter("date")(
                statementDetail.details[m].reporteddate,
                "yyyy-MM-dd"
              )
            : "0",
          alignment: "right",
        });
        if (statementDetail.details[m].external_project_name) {
          statementDetail.details[m].project_name =
            statementDetail.details[m].external_project_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].project_name
            ? statementDetail.details[m].project_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].name
            ? statementDetail.details[m].name.toString()
            : "",
        });
        if (statementDetail.details[m].external_activity_name) {
          statementDetail.details[m].activity_name =
            statementDetail.details[m].external_activity_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].activity_name
            ? statementDetail.details[m].activity_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].sum.toString(),
          alignment: "right",
        });
      }
    }

    if (statement.detailMode === "W") {
      detailHeader.unshift([
        { text: "Vecka", style: "tableHeader", alignment: "left" },
      ]);
      detailWidths.unshift(["auto"]);
      for (m = 0; m < statementDetail.details.length; m++) {
        invoice.details[m] = [];
        invoice.details[m].push({
          text: statementDetail.details[m].reportweek
            ? $filter("date")(statementDetail.details[m].reportweek, "yyyy Vww")
            : "0",
          alignment: "left",
        });
        if (statementDetail.details[m].external_project_name) {
          statementDetail.details[m].project_name =
            statementDetail.details[m].external_project_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].project_name
            ? statementDetail.details[m].project_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].name
            ? statementDetail.details[m].name.toString()
            : "",
        });
        if (statementDetail.details[m].external_activity_name) {
          statementDetail.details[m].activity_name =
            statementDetail.details[m].external_activity_name;
        }
        invoice.details[m].push({
          text: statementDetail.details[m].activity_name
            ? statementDetail.details[m].activity_name.toString()
            : "",
        });
        invoice.details[m].push({
          text: statementDetail.details[m].sum.toString(),
          alignment: "right",
        });
      }
    }

    var detailBody = [];
    detailBody.push(detailHeader);

    var detailTable = {
      widths: detailWidths,
      headerRows: 1,
      body: detailBody.concat(invoice.details),
    };
    var amounts = {};
    amounts.net = Math.round10(statementDetail.pris * 100) / 100;
    amounts.vat = Math.round10(100 * statementDetail.pris * 0.25) / 100;
    amounts.oreRounding =
      Math.round10(amounts.net + amounts.vat) - (amounts.net + amounts.vat);
    if (
      amounts.oreRounding > 0.0 &&
      statementDetail.statementType &&
      statementDetail.statementType === "kredit"
    ) {
      amounts.oreRounding = -amounts.oreRounding;
    }
    invoice.netAmount = statementDetail.pris
      ? $filter("number")(amounts.net, 2)
      : "0";
    invoice.vatAmount = $filter("number")(amounts.vat, 2);

    invoice.rounding = $filter("number")(amounts.oreRounding, 2);
    invoice.totalAmount = $filter("number")(
      amounts.net + amounts.vat + amounts.oreRounding,
      2
    );

    var content = [
      {
        columns: [
          {
            width: "auto",
            layout: "noBorders",
            table: {
              body: [
                [{ text: invoiceHeader, fontSize: 36 }],
                [
                  {
                    image:
                      "data:image/png;base64,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",
                    width: 150,
                  },
                ],
                [
                  {
                    alignment: "left",
                    stack: [
                      invoice.companyName,
                      invoice.companyAdress1,
                      invoice.companyAdress2,
                      invoice.companyZipcode + " " + invoice.companyCity,
                      invoice.companyCountry,
                    ],
                  },
                ],
              ],
            },
          },
          {
            layout: "noBorders",
            table: {
              widths: ["auto", "*"],
              body: [
                [{ text: "Fakturanr", bold: true }, invoice.invoiceNo],
                [{ text: "Datum", bold: true }, invoice.date],
                [
                  {
                    text: "Betalningsvilkor",
                    bold: true,
                    margin: [0, 0, 0, 10],
                  },
                  invoice.terms,
                ],
                [{ text: "Kund", bold: true }, invoice.customerName],
                [{ text: "Orgnr", bold: true }, invoice.customerOrgNo],
                [{ text: "Momsregnr", bold: true }, invoice.customerVATNo],
                [
                  { text: "Fakturaadress", bold: true, margin: [0, 0, 0, 10] },
                  {
                    stack: [
                      invoice.customerAdress1,
                      invoice.customerAdress2,
                      invoice.customerZipcode + " " + invoice.customerCity,
                      invoice.customerCountry,
                    ],
                  },
                ],
                [
                  { text: "Kund kontaktperson", bold: true },
                  invoice.customerContact,
                ],
                [
                  { text: "Kund Referens", bold: true, margin: [0, 0, 0, 10] },
                  invoice.customerRef,
                ],
                [
                  { text: "Vår kontaktperson", bold: true },
                  invoice.companyContact,
                ],
                [
                  { text: "Vår Referens", bold: true, margin: [0, 0, 0, 10] },
                  invoice.companyRef,
                ],
                [
                  { text: "Fakturan avser tid mellan", bold: true },
                  invoice.period_start + "-" + invoice.period_stop,
                ],
              ],
            },
          },
        ],
      },
    ];

    if (invoice.details.length !== 0) {
      content.push({
        margin: [0, 40, 0, 0],
        table: detailTable,
        layout: "lightHorizontalLines",
      });
    }

    content.push({
      margin: [0, 40, 0, 0],
      columns: [
        {},
        {
          table: {
            widths: ["*", "auto"],
            body: [
              ["Netto", { text: invoice.netAmount, alignment: "right" }],
              ["Moms 25%", { text: invoice.vatAmount, alignment: "right" }],
              [
                "Öresavrundning",
                { text: invoice.rounding, alignment: "right" },
              ],
              [
                { text: totAmount, style: "headerTot" },
                {
                  text: invoice.totalAmount,
                  style: "headerTot",
                  alignment: "right",
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return 0;
              } else {
                return i === node.table.body.length - 1 ? 2 : 1;
              }
            },
            hLineColor: function (i, node) {
              return i === node.table.body.length - 1 ? "black" : "gray";
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            vLineColor: function (i, node) {
              return "gray";
            },
            paddingLeft: function (i, node) {
              return 0;
            },
            paddingRight: function (i, node) {
              return 0;
            },
            // paddingTop: function(i, node) { return 2; },
            // paddingBottom: function(i, node) { return 2; }
          },
        },
      ],
    });

    var styles = {
      header: {
        fontSize: 18,
        bold: true,
      },
      headerTot: {
        fontSize: 12,
        bold: true,
      },
      normal: {
        fontSize: 8,
      },
      italic: {
        italics: true,
      },
      gap: {
        columnGap: 40,
      },
    };

    var defaultStyle = {
      columnGap: 20,
      fontSize: 8,
    };

    var header = function (curr, count) {
      var head = {
        columns: [
          { text: "", alignment: "left" },
          { text: "", alignment: "center" },
          { text: curr + "(" + count + ")", alignment: "right" },
        ],
        margin: [40, 20, 40, 0],
      };
      return head;
    };

    var footer = [
      {
        margin: [40, 0, 40, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                italics: true,
                text: "Anmärkningar mot denna faktura skall göras inom 8 dagar. Efter förfallodagen debiteras dröjsmålsränta med referensränta +8%",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === node.table.body.length ? "black" : "gray";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length ? "black" : "gray";
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 2;
          },
          paddingBottom: function (i, node) {
            return 2;
          },
        },
      },
      {
        margin: [40, 2, 40, 0],
        columns: [
          {
            alignment: "left",
            stack: [
              "Kok i tot sos AB, Box 5038, 40221 Göteborg",
              "Företagets säte: Göteborg",
              "Org nr: 556930-4685",
              "Momsregnr:  SE556930468501",
            ],
          },
          {
            alignment: "right",
            stack: [
              "faktura@kits.se | +46733589055",
              "BankGiro: 369-6077",
              "IBAN: SE3050000000050011161272",
              "BIC: ESSESESS",
            ],
          },
        ],
      },
    ];

    var docDefinition = {
      content: content,
      styles: styles,
      defaultStyle: defaultStyle,
      header: header,
      footer: footer,
      pageSize: "A4",
      pageMargins: [40, 60, 40, 80],
    };

    //console.log(docDefinition);
    //pdfMake.createPdf(docDefinition).open();
    return docDefinition;
  };

  var viewInvoice = function (statement) {
    //var kiki = pdfMake.createPdf(createPdf(statement));
    //pdfMake.createPdf(createPdf(statement)).open();
  };

  var downloadInvoice = function (statement) {
    var st = JSON.parse(statement.statement);
    var statementType = st.statementType === "kredit" ? "kreditfaktura " : "";
    var name =
      config.company +
      " " +
      statementType +
      statement.invoice_number +
      " " +
      statement.customername +
      ".pdf";
    //pdfMake.createPdf(createPdf(statement)).download(name);
  };

  return {
    viewInvoice: viewInvoice,
    downloadInvoice: downloadInvoice,
  };
});
